import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const rocketChat = defineConnector({
  identifier: "rocketChat",
  name: "Rocket.Chat",
  tagLine: "Open source team communication",
  logo,
  protocol: "http",
  tags: ["communication"],
  defaultUrlPattern: ({ domain }) =>
    domain
      ? `https://${domain.replace(/\./g, "\\.")}/.*`
      : "https://[^/]*\\.rocket\\.chat/.*",
  auth: (app) =>
    headerAuth([
      { name: "X-Auth-Token", value: app.secret.authToken },
      { name: "X-User-Id", value: app.config.userId },
    ]),
  steps: [
    {
      title: "Enter your Rocket.Chat instance",
      items: [
        {
          kind: "input",
          label: "Instance domain",
          required: true,
          placeholder: "your-workspace.rocket.chat",
          target: { kind: "configuration", field: "domain" },
        },
      ],
    },
    {
      title: "Create a personal access token",
      items: [
        {
          kind: "markdown",
          content:
            "In Rocket.Chat, go to **Profile › Personal Access Tokens** and create a new token. You will need both the token and your user ID.",
        },
        {
          kind: "input",
          label: "User ID",
          required: true,
          target: { kind: "configuration", field: "userId" },
        },
        {
          kind: "input",
          label: "Auth token",
          required: true,
          target: { kind: "secrets", field: "authToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ domain }) => `https://${domain}/api/v1/me`,
  },
});
